import { render, staticRenderFns } from "./DetailModal.vue?vue&type=template&id=db0a4b46&scoped=true"
import script from "./DetailModal.vue?vue&type=script&lang=js"
export * from "./DetailModal.vue?vue&type=script&lang=js"
import style0 from "./DetailModal.vue?vue&type=style&index=0&id=db0a4b46&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db0a4b46",
  null
  
)

export default component.exports